'use strict';
// TODO: Remove from `core-js@4`
require('../modules/es.typed-array.with');



// WEBPACK FOOTER //
// ./~/core-js/modules/esnext.typed-array.with.js